import { render, staticRenderFns } from "./authenticate.vue?vue&type=template&id=fce99ad8&scoped=true"
import script from "./authenticate.vue?vue&type=script&lang=js"
export * from "./authenticate.vue?vue&type=script&lang=js"
import style0 from "./authenticate.vue?vue&type=style&index=0&id=fce99ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce99ad8",
  null
  
)

export default component.exports